import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Wrong network',
    text1: 'The current page is not available on ',
    thisFeatureIsNotAvailable: 'This feature is not available',
    pleaseSwitchTo: 'Please switch to',
    pleaseSwitchToSupported: 'Please switch to a supported network',
    switchTo: 'Switch to {chain}',
    switchNetworkError: 'Failed to switch network',
  },
};
